// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__LsylF","namePhoneContainer":"style_namePhoneContainer__JTUNQ"};